import { put, takeLatest, call, all } from "redux-saga/effects";
import axios from "axios";
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  CUBICASA_UNSYNCED_LIST_REQUEST,
  CUBICASA_UNSYNCED_LIST_SUCCESS,
  CUBICASA_UNSYNCED_LIST_FAILED,
  CUBICASA_MARK_SYNCED_REQUEST,
  CUBICASA_MARK_SYNCED_SUCCESS,
  CUBICASA_MARK_SYNCED_FAILED,
} from "../../../_utils/constants/CubiCasa";

function* fetchUnSyncedCubiCasaList({ token, take }) {
  try {
    const response = yield call(
      axios.get,
      `${API_URL}/api/cubicasa/webhooks?isSynced=false&take=${take || 100}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put({ type: CUBICASA_UNSYNCED_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CUBICASA_UNSYNCED_LIST_FAILED,
        payload: error.response,
      });
    }
  }
}

function* markCubiCasaSynced({ token, logId, payload }) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/api/cubicasa/webhooks/${logId}/mark-synced`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put({ type: CUBICASA_MARK_SYNCED_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CUBICASA_MARK_SYNCED_FAILED,
        payload: error.response,
      });
    }
  }
}

export default function* rootCubiCasa() {
  yield all([
    takeLatest(CUBICASA_UNSYNCED_LIST_REQUEST, fetchUnSyncedCubiCasaList),
    takeLatest(CUBICASA_MARK_SYNCED_REQUEST, markCubiCasaSynced),
  ]);
}
